/** Тексты экрана успеха Wallapop (ES). */
export const wallapopSuccessCopy = {
  searchPlaceholder: 'Buscar en todas las categorías',
  favorites: 'Favoritos',
  inbox: 'Buzón',
  you: 'Tú',
  sell: 'Vender',
  mainTitle: 'El producto se compró',
  secureLine: 'El comprador ya ha pagado por su producto, el dinero está a salvo, cójalo.',
  cta: 'Obtener dinero',
  tealSecureTitle: 'Compras seguras',
  tealSecureBody:
    'Todos los pagos de Wallapop están cifrados y garantizados por nuestro socio de pagos, Adyen, para proteger el dinero que envías y recibes.',
  tealSupportTitle: 'Nuestro apoyo',
  tealSupportBody:
    'Nuestro equipo de soporte está disponible las 24 horas del día; el tiempo de respuesta habitual es inferior a 24 horas. Las incidencias relacionadas con el cobro o la recepción del dinero tienen prioridad.',
};
